import { render, staticRenderFns } from "./TableDynamicServerSideV2.vue?vue&type=template&id=71cdda6c&scoped=true&"
import script from "./TableDynamicServerSideV2.vue?vue&type=script&lang=js&"
export * from "./TableDynamicServerSideV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cdda6c",
  null
  
)

export default component.exports